import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Col, Form, Modal, Row, Switch, Tabs } from "antd";
import { IMask } from 'react-imask';
import moment from "moment";
import { employeesService } from "./../../redux/services";
import Adresses from "./Adresses"
import Contacts from "./Contacts"
import Contracts from "./Contracts"
import { checkIfAvatarIsValid } from "../../utils/checkAvatar";
import defaultAvatar from '../../images/default-profile.png';
import {
	UIDrawerForm,
	UIFormSection,
	UISwitchField,
	UIUpload,
} from "./../../components";
import { STEPS } from "./edit";

class Show extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onClose: PropTypes.func.isRequired,
		external: PropTypes.bool,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			uuid: 0,
			item: {},
			general_key: null,
			avatar: null,
			contract: null,
			displayParamsREPP: true,
			displayAppCompany: true,
			displayAppEmployee: true
		};
	}

	componentDidMount() {
		this.handleCheckCompanyHasAccessREPP();
	}

	onOpen = (uuid, key) => {
		this.setState({
			isLoading: true,
			uuid: uuid,
			item: {},
			general_key: key,
		});

		employeesService.show({ uuid })
			.then((response) => {
				let item = response.data.data;

				if (item.contrato == null) {
					const current_contract = response.data.historico_contratos[response.data.historico_contratos.length - 1];
					item.contrato = current_contract;
				}

				this.setState({
					isLoading: false,
					item: item,
				}, () => {
					// Upload
					if (item.avatar) {
						const file = {
							uuid: item.uuid,
							url: item.avatar,
							type: 'image/jpeg',
						}
				
						this.upload.setFiles([file]);

						// removido por enquanto
						// checkIfAvatarIsValid(item.avatar).then(_ => {
						// 	console.log(res.status)
						// 		if (res.status !== 200) {
						// 			file.url = defaultAvatar;
						// 			this.upload.setFiles([file]);
						// 			return;
						// 		}

						// 	}).catch(error => {
						// 		console.log({ error })
						// 		console.log('ai papai')
						// 		file.url = defaultAvatar;
						// 		this.upload.setFiles([file]);
						// 	});
					}

					// Load options
					this.tabAdresses && this.tabAdresses.init(item);
					this.tabContacts && this.tabContacts.init(item);
					this.tabContracts && this.tabContracts.init(item);
				});
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
					onOk: () => {
						// Force close
						return this.onClose();
					}
				});
			});
	};

	resetFields = () => {
		this.setState({
			item: {},
		});
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	handleCheckCompanyHasAccessREPP = () => {
		const companyData = JSON.parse(localStorage.getItem('@mainCompany'));

		this.setState({
			displayParamsREPP: !(!companyData?.app_empresa && !companyData?.app_funcionario),
			displayAppCompany: companyData?.app_empresa,
			displayAppEmployee: companyData?.app_funcionario
		});
	}
	
	render() {
		const { visible } = this.props;
		const {
			isLoading,
			item,
			general_key,
			displayParamsREPP,
			displayAppCompany,
			displayAppEmployee
		} = this.state;

		return (
			<UIDrawerForm
				visible={visible}
				width={1100}
				onClose={this.onClose}
				isLoading={isLoading}
				showBtnSave={false}
				icon={<i className="fal fa-users" />}
				title="Visualizar funcionário"
				subtitle="Consulte os dados do funcionário.">
				<Form layout="vertical">
					<Tabs defaultActiveKey={general_key != null ? general_key : "general"}>
						<Tabs.TabPane forceRender tab={<span className="tab-icon-label">{STEPS[0].icon} {STEPS[0].label}</span>} key="general">
							<UIFormSection
								icon={<i className="fal fa-user" />}
								title="Dados pessoais"
								description="Identificação e dados pessoais do funcionário."
							>
								<Row gutter={16}>
									<Col xs={24} md={4}>
										<UIUpload
											ref={el => this.upload = el}
											label="Foto"
											acceptedFiles={['jpg', 'jpeg', 'png']}
											disabled
										/>
									</Col>
									<Col xs={24} md={20}>
										<Row gutter={16}>
											<Col xs={24} md={16}>
												<Form.Item label="Nome">
													{item.nome ?? "-"}
												</Form.Item>
											</Col>
											<Col xs={24} md={8}>
												<Form.Item label="CPF">
													{item.cpf ?? "-"}
												</Form.Item>
											</Col>
										</Row>
										<Row gutter={16}>
											<Col xs={24} md={8}>
												<Form.Item label="Data de nascimento">
													{item.data_nascimento ? moment(item.data_nascimento).format("DD/MM/YYYY") : "-"}
												</Form.Item>
											</Col>
											<Col xs={24} md={8}>
												<Form.Item label="Sexo">
													{item.sexo != null ? (item.sexo == 0 ? "Masculino" : "Feminino") : "-"}
												</Form.Item>
											</Col>
											<Col xs={24} md={8}>
												<Form.Item label="Nacionalidade">
													{item.nacionalidade ?? "-"}
												</Form.Item>
											</Col>
										</Row>
									</Col>
								</Row>
								<Row gutter={16}>
									<Col xs={24} md={8}>
										<Form.Item label="Naturalidade">
											{item.naturalidade ?? "-"}
										</Form.Item>
									</Col>
									<Col xs={24} md={8}>
										<Form.Item label="Nome do pai">
											{item.nome_pai ?? "-"}
										</Form.Item>
									</Col>
									<Col xs={24} md={8}>
										<Form.Item label="Nome da mãe">
											{item.nome_mae ?? "-"}
										</Form.Item>
									</Col>
								</Row>
								<Row gutter={16}>
									<Col xs={24} md={8}>
										<UISwitchField
											bordered
											title="Ativo"
											description={item.ativo == 1 ? "Funcionário ativo no sistema." : "Funcionário inativo no sistema."}
										>
											<Switch disabled checked={item.ativo == 1} />
										</UISwitchField>
									</Col>
									<Col xs={24} md={8}>
										<Form.Item label="Criação">
											{item.created_at ? moment(item.created_at).calendar() : "-"}
										</Form.Item>
									</Col>
								</Row>
							</UIFormSection>
							<UIFormSection
								icon={<i className="fal fa-id-card" />}
								title="Documentos"
								description="Documentos e números de identificação usados na folha e no ponto."
							>
								<Row gutter={16}>
									<Col xs={24} md={8}>
										<Form.Item label="Número da folha">
											{item.numero_folha ?? "-"}
										</Form.Item>
									</Col>
									<Col xs={24} md={8}>
										<Form.Item label="Número do identificador">
											{item.numero_identificador ?? "-"}
										</Form.Item>
									</Col>
									<Col xs={24} md={8}>
										<Form.Item label="PIS/PASEP">
											{item.pis_pasep ? IMask.pipe(`${item.pis_pasep}`, {mask: '000.00000.00-0'}) : "-"}
										</Form.Item>
									</Col>
								</Row>
								<Row gutter={16}>
									<Col xs={24} md={6}>
										<Form.Item label="CTPS">
											{item.ctps ?? "-"}
										</Form.Item>
									</Col>
									<Col xs={24} md={6}>
										<Form.Item label="RG">
											{item.rg ?? "-"}
										</Form.Item>
									</Col>
									<Col xs={24} md={6}>
										<Form.Item label="Data de expedição">
											{item.rg_data_expedicao ? moment(item.rg_data_expedicao).format("DD/MM/YYYY") : "-"}
										</Form.Item>
									</Col>
									<Col xs={24} md={6}>
										<Form.Item label="SSP">
											{item.rg_ssp ?? "-"}
										</Form.Item>
									</Col>
								</Row>
							</UIFormSection>
						</Tabs.TabPane>
						<Tabs.TabPane forceRender tab={<span className="tab-icon-label">{STEPS[1].icon} {STEPS[1].label}</span>} key="contracts">
							<Contracts
								showOnly={true}
								ref={el => this.tabContracts = el}
							/>
						</Tabs.TabPane>
						{displayParamsREPP && (
							<Tabs.TabPane forceRender tab={<span className="tab-icon-label">{STEPS[2].icon} {STEPS[2].label}</span>} key="app">
								<UIFormSection
									icon={<i className="fal fa-mobile-alt" />}
									title="Aplicativos"
									description="Acesso do funcionário aos aplicativos de registro de ponto."
								>
									<Row gutter={16}>
										{displayAppEmployee && (
											<Col xs={24} md={12}>
												<UISwitchField
													bordered
													title="Aplicativo do funcionário"
													description="Libera o app do funcionário, com acesso por e-mail e senha."
												>
													<Switch disabled checked={!!item.app} />
												</UISwitchField>
												{!!item.app && (
													<Form.Item label="E-mail" style={{ marginTop: 16 }}>
														{item.email ?? "-"}
													</Form.Item>
												)}
											</Col>
										)}
										{displayAppCompany && (
											<Col xs={24} md={12}>
												<UISwitchField
													bordered
													title="Aplicativo da empresa"
													description="Permite registrar o ponto no app da empresa usando um PIN."
												>
													<Switch disabled checked={!!item.habilitar_app_empresa} />
												</UISwitchField>
												{!!item.habilitar_app_empresa && (
													<Form.Item label="PIN" style={{ marginTop: 16 }}>
														{item.pin ?? "-"}
													</Form.Item>
												)}
											</Col>
										)}
									</Row>
								</UIFormSection>
								{!!item.app && (
									<UIFormSection
										icon={<i className="fal fa-user-lock" />}
										title="Permissões no aplicativo"
										description="O que o funcionário pode fazer pelo app."
									>
										<Row gutter={[16, 16]}>
											<Col xs={24} md={8}>
												<UISwitchField bordered title="Registrar ponto" description="Registra o ponto pelo app.">
													<Switch disabled checked={!!item.permitir_registro_app} />
												</UISwitchField>
											</Col>
											<Col xs={24} md={8}>
												<UISwitchField bordered title="Assinar cartão ponto" description="Assina o cartão ponto pelo app.">
													<Switch disabled checked={!!item.permitir_assinar_cartao_app} />
												</UISwitchField>
											</Col>
											<Col xs={24} md={8}>
												{!!item.permitir_assinar_cartao_app && (
													<UISwitchField bordered title="Exigir senha ao assinar" description="Pede a senha do app na assinatura.">
														<Switch disabled checked={!!item.exigir_senha_assinatura} />
													</UISwitchField>
												)}
											</Col>
											<Col xs={24} md={8}>
												<UISwitchField bordered title="Anexar justificativas e marcações manuais" description="Envia justificativas e marcações pelo app.">
													<Switch disabled checked={!!item.permitir_justificativa_parcial_app} />
												</UISwitchField>
											</Col>
											<Col xs={24} md={8}>
												{!!item.permitir_justificativa_parcial_app && (
													<UISwitchField bordered title="Aprovar justificativas automaticamente" description="Justificativas enviadas pelo app entram aprovadas.">
														<Switch disabled checked={!!item.justificativa_parcial_app_auto_aprovar} />
													</UISwitchField>
												)}
											</Col>
										</Row>
									</UIFormSection>
								)}
								<UIFormSection
									icon={<i className="fal fa-map-marker-alt" />}
									title="Registro de ponto"
									description="Regras aplicadas na marcação pelo app."
								>
									<Row gutter={16}>
										<Col xs={24} md={12}>
											<UISwitchField bordered title="Envio de selfie" description="Exige uma selfie a cada registro de ponto.">
												<Switch disabled checked={!!item.envio_self} />
											</UISwitchField>
										</Col>
										{(!!item.habilitar_app_empresa || !!item.app) && (
											<Col xs={24} md={12}>
												<Form.Item label="Perímetro">
													{item.perimetro ? item.perimetro.nome : "-"}
												</Form.Item>
											</Col>
										)}
									</Row>
								</UIFormSection>
							</Tabs.TabPane>
						)}
						<Tabs.TabPane forceRender tab={<span className="tab-icon-label">{STEPS[3].icon} {STEPS[3].label}</span>} key="equipments">
							<UIFormSection
								icon={<i className="fal fa-fingerprint" />}
								title="Credenciais do equipamento"
								description="Dados de acesso do funcionário no relógio de ponto (REP-C)."
							>
								<Row gutter={16}>
									<Col xs={24} md={8}>
										<Form.Item label="Senha do equipamento">
											{item.equipamento_senha ?? "-"}
										</Form.Item>
									</Col>
									<Col xs={24} md={8}>
										<Form.Item label="Código de barras">
											{item.equipamento_codigo_barras ?? "-"}
										</Form.Item>
									</Col>
									<Col xs={24} md={8}>
										<Form.Item label="RFID">
											{item.equipamento_rfid ?? "-"}
										</Form.Item>
									</Col>
								</Row>
								<Row gutter={[16, 16]}>
									<Col xs={24} md={8}>
										<UISwitchField bordered title="Enviar RFID" description="Envia o RFID do funcionário ao equipamento.">
											<Switch disabled checked={item.equipamento_enviar_rfid == 1} />
										</UISwitchField>
									</Col>
									<Col xs={24} md={8}>
										<UISwitchField bordered title="Administrador" description="Funcionário é administrador do equipamento.">
											<Switch disabled checked={item.equipamento_admin == 1} />
										</UISwitchField>
									</Col>
									<Col xs={24} md={8}>
										<UISwitchField bordered title="Biometria" description="Funcionário usa biometria no equipamento.">
											<Switch disabled checked={item.equipamento_biometria == 1} />
										</UISwitchField>
									</Col>
								</Row>
							</UIFormSection>
						</Tabs.TabPane>
						<Tabs.TabPane forceRender tab={<span className="tab-icon-label">{STEPS[4].icon} {STEPS[4].label}</span>} key="adresses">
							<Adresses
								showOnly={true}
								ref={el => this.tabAdresses = el}
							/>
						</Tabs.TabPane>
						<Tabs.TabPane forceRender tab={<span className="tab-icon-label">{STEPS[5].icon} {STEPS[5].label}</span>} key="contacts">
							<Contacts
								showOnly={true}
								ref={el => this.tabContacts = el}
							/>
						</Tabs.TabPane>
					</Tabs>
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Show;
